<template>
  <CenteredContainer>
    <SfHeading
      class="sf-heading--left m-b-20"
      :level="2"
      :title="$t('Forgot password')"
    />
    <form class="form" @submit.prevent="resetPassword">
      <SfInput
        v-model="email"
        name="email"
        label="E-mail"
        class="form__element"
        type="email"
        required
      />
      <SfButton type="submit" class="sf-button--full-width form__submit">
        {{ $t('Reset Password') }}
      </SfButton>
    </form>
    <SfButton @click="goToLogin" class="sf-button--text action-button">
      {{ $t('Return to log in') }}
    </SfButton>
  </CenteredContainer>
</template>
<script>
import {
  SfInput,
  SfButton,
  SfHeading,
} from '@storefront-ui/vue';

import user from '../mixins/user';
import CenteredContainer from '../components/CenteredContainer.vue';

export default {
  name: 'ForgotPassword',
  mixins: [user],
  components: {
    SfInput,
    SfButton,
    SfHeading,
    CenteredContainer,
  },
  data() {
    return {
      email: '',
    };
  },
  methods: {
    resetPassword() {
      this.forgotPassword({
        email: this.email,
      })
        .then(() => {
          console.log('Done');
        })
        .cache(() => {
          console.log('Error');
        });
    },
    goToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>
<style lang="scss" scoped>
.form {
  width: 100%;
  &__element {
    margin: var(--spacer-base) 0;
  }
  &__checkbox {
    margin: var(--spacer-xl) 0 var(--spacer-2xl) 0;
  }
  &__submit {
    margin: var(--spacer-xl) 0 0 0;
  }
}
.action-button {
  margin: var(--spacer-xl) 0;
}
</style>
